import { useState } from "react";
import { useNavigate } from "react-router-dom";

const display = { fontFamily: "'Fraunces', serif" };

function AdminLogin() {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [shake, setShake] = useState(false);
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
            sessionStorage.setItem("isAdmin", "true");
            navigate("/admin/dashboard");
        } else {
            setError("Incorrect password. Try again.");
            setShake(true);
            setTimeout(() => setShake(false), 500);
        }
    };

    return (
        <div
            className="min-h-screen w-full flex items-center justify-center px-5"
            style={{ background: "linear-gradient(180deg, #EAF2FF 0%, #FBF9F2 55%, #FFFFFF 100%)" }}
        >
            <style>{`
        @keyframes badge-in { 0% { opacity:0; transform: scale(.85); } 100% { opacity:1; transform: scale(1); } }
        @keyframes shake { 10%,90% { transform: translateX(-1px); } 20%,80% { transform: translateX(2px); } 30%,50%,70% { transform: translateX(-4px); } 40%,60% { transform: translateX(4px); } }
        .badge-in { animation: badge-in .5s cubic-bezier(.2,.8,.2,1); }
        .shake { animation: shake .5s; }
        .admin-input::placeholder { color: #9AA7BD; }
      `}</style>

            <div className="w-full max-w-[380px]">
                <div className="badge-in flex flex-col items-center mb-8">
                    <div
                        className="w-16 h-16 rounded-full flex items-center justify-center mb-4 shadow-lg"
                        style={{ background: "linear-gradient(155deg, #4B8AFF, #2F6FED)" }}
                    >
                        <span className="text-white text-xl font-bold" style={display}>M</span>
                    </div>
                    <p className="text-[10px] tracking-[0.3em] uppercase text-[#7E8CA6] font-semibold">
                        Private Access
                    </p>
                </div>

                <div
                    className={`rounded-2xl p-8 bg-white ${shake ? "shake" : ""}`}
                    style={{
                        border: "1px solid rgba(47,111,237,0.12)",
                        boxShadow: "0 20px 50px rgba(47,111,237,0.12)",
                    }}
                >
                    <h1 className="text-[#1F2937] text-2xl mb-1 text-center" style={display}>
                        Admin Panel
                    </h1>
                    <p className="text-[#64748B] text-xs text-center mb-7">
                        homeschoolingwithmbu.com
                    </p>

                    <form onSubmit={handleLogin} className="space-y-4">
                        <div>
                            <label className="block text-[10px] uppercase tracking-[0.15em] text-[#64748B] font-semibold mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                autoComplete="current-password"
                                placeholder="••••••••••"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    if (error) setError("");
                                }}
                                required
                                className="admin-input w-full px-4 py-3 rounded-xl text-[#1F2937] text-sm outline-none transition-colors"
                                style={{
                                    background: "#F5F9FF",
                                    border: `1px solid ${error ? "#DC2626" : "rgba(47,111,237,0.15)"}`,
                                }}
                                onFocus={(e) => (e.target.style.borderColor = "#2F6FED")}
                                onBlur={(e) =>
                                    (e.target.style.borderColor = error ? "#DC2626" : "rgba(47,111,237,0.15)")
                                }
                            />
                        </div>

                        {error && (
                            <p className="text-[#DC2626] text-xs flex items-center gap-1.5">
                                <span>⚠</span> {error}
                            </p>
                        )}

                        <button
                            type="submit"
                            className="w-full py-3 rounded-xl font-semibold text-sm text-white transition-all hover:brightness-110 active:scale-[0.98]"
                            style={{ background: "linear-gradient(155deg, #4B8AFF, #2F6FED)" }}
                        >
                            Enter Dashboard
                        </button>
                    </form>
                </div>

                <p className="text-center text-[#9AA7BD] text-[11px] mt-6">Internal tool — not for customers</p>
            </div>
        </div>
    );
}

export default AdminLogin;